import styled from 'styled-components';

export const CellButtonLink = styled('button')`
  display: block;
  padding: ${({ theme }) => `${theme.x1spacePx + 2}px ${theme.x1spacePx}px`};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
  color: inherit;
  text-align: inherit;
  width: 100%;
`;

export const Name = styled('td')`
  max-width: 100px;
`;

interface Props {
  value: null | number;
}

export const PE = styled('td')<Props>`
  color: ${({ value, theme }) =>
    theme.color.whiteRGBA(value === null ? 0.3 : 1)};
`;
